export enum TimeWithinRangePrecision {
  Precision02 = '0.2',
  Precision05 = '0.5',
  Precision10 = '1.0',
  Precision20 = '2.0',
}